import React, { useCallback } from 'react';

// GLOBAL FUNCTIONS
import { documentChunkFetch, getFileType, viewFile } from 'functions.js';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// MAIN COMPONENT
const ViewPDFLink = ({
  endpoint,
  fileName,
  ...props
}) => {

  // CALLBACKS
  const handleClick = useCallback(
    () => {
      documentChunkFetch({
        endpoint,
        mimeType: getFileType(fileName) || 'text/plain',
        contentType: 'application/json',
        loadingMessage: 'Opening file',
        errorMessage: 'Unable to download file.',
        onSuccess: r => viewFile({ ...r, fileName }),
      })
    },
    [endpoint, fileName]
  )

  // RENDER
  return (
    <Button.Link
      label="View PDF"
      onClick={handleClick}
      {...props}
    />
  )
}

// EXPORT
export default ViewPDFLink
